import React from "react";
import Hero from "../components/Hero";
import Aboutme from "../components/Aboutme";
import Projects from "../components/Projects";
import Footer from "../components/Footer";

const Portfolio = () => {
  var paragraph = "I am a final-semester bachelor of architecture student at ETH Zurich. Studying under professors like Deplazes, Boltshauser, Voser, and Beer and Merz has shaped my design approach. I focus on sustainable, simple yet unique solutions.";
  var secondParagraph = "My work spans small alpine renovations, large-scale urban designs in Pobleou, landscape projects in Ticino, and urban renovations in line with monument preservation guides, balancing function, aesthetics, and sustainability while responding to each project's context.";

  return (
    <>
      <Hero mainPage={true} />
      <Aboutme paragraph={paragraph} secondParagraph={secondParagraph}/>
      <Projects />
      <Footer />
    </>
  );
};

export default Portfolio;
